import AreaPage from "./AreaPage";
export default AreaPage;
